<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <!-- Small loader for content -->
  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!loading) {
<div>
    <!-- JSON View Section -->
    <div style="margin-top:15px">
      <div style="width: 100%;">
        <pre class="json_view">{{jsonView}}</pre>
      </div>
    </div>
  </div>
}
</div>

<!-- STANDARD Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
